export const generateClubPayload = (data: ClubFormData): ClubSavePayloadData => {
  const payload = {
    name: data.name,
    address: generateAddress(data),
    timeZone: data.timeZone,
    email: data.email,
    phone: data.phone,
    url: data.url,
    billingContactName: data.billingContactName,
    billingContactPhone: data.billingContactPhone,
    billingContactEmail: data.billingContactEmail,
    billingAddress: generateBillingAddress(data),
  }
  Object.keys(payload).forEach((field) => (payload[field] = payload[field] === '' ? null : payload[field]))
  return payload
}

const generateAddress = (data: ClubFormData): AddressPayload => {
  const { streetAddress, streetAddress2, postalCode, city, state, country } = data

  return {
    ...(streetAddress && { streetAddress }),
    ...(streetAddress2 && { streetAddress2 }),
    ...(postalCode && { postalCode }),
    ...(city && { city }),
    ...(state?.key && { state: maybeConvertStringToNumber(state.key) }),
    ...(country?.key && { country: maybeConvertStringToNumber(country.key) }),
  }
}

const generateBillingAddress = (data: ClubFormData): AddressPayload | null => {
  const {
    billingContactAddress,
    billingContactAddress2,
    billingContactPostalCode,
    billingContactCity,
    billingContactCountry,
  } = data

  const billingAddress = {
    ...(billingContactAddress && { streetAddress: billingContactAddress }),
    ...(billingContactAddress2 && { streetAddress2: billingContactAddress2 }),
    ...(billingContactPostalCode && { postalCode: billingContactPostalCode }),
    ...(billingContactCity && { city: billingContactCity }),
    ...(billingContactCountry?.key && { country: maybeConvertStringToNumber(billingContactCountry.key) }),
  }
  return Object.keys(billingAddress).length > 0 ? billingAddress : null
}

const maybeConvertStringToNumber = (value: number | string): number => {
  return typeof value === 'string' ? parseInt(value) : value
}
